var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8001 4H5.59999C4.64 4 4 4.64 4 5.59999V16.8001C4 17.76 4.64 18.4001 5.59999 18.4001H16.8001C17.76 18.4001 18.4001 17.76 18.4001 16.8001V5.59999C18.4001 4.64 17.76 4 16.8001 4ZM16.8001 21.6001H5.59999C4.64 21.6001 4 22.24 4 23.2001V34.4C4 35.36 4.64 36 5.59999 36H16.8001C17.76 36 18.4001 35.36 18.4001 34.4V23.2001C18.4001 22.24 17.76 21.6001 16.8001 21.6001ZM34.4 4H23.2001C22.24 4 21.6001 4.64 21.6001 5.59999V16.8001C21.6001 17.76 22.24 18.4001 23.2001 18.4001H34.4C35.36 18.4001 36 17.76 36 16.8001V5.59999C36 4.64 35.36 4 34.4 4ZM34.4 21.6001H23.2001C22.24 21.6001 21.6001 22.24 21.6001 23.2001V34.4C21.6001 35.36 22.24 36 23.2001 36H34.4C35.36 36 36 35.36 36 34.4V23.2001C36 22.24 35.36 21.6001 34.4 21.6001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIcon);
export default __webpack_public_path__ + "static/media/ApplicationIcon.33880aba4958ccfb6168baba354014a7.svg";
export { ForwardRef as ReactComponent };